<template>
    <div class="modal-cont abs-center">
      <div class="modal " >
      <div class="modal-nav">
          <div class="modal-nav-close-btn" @click="close"></div>
      </div>
      <div id="video" class="video" v-show='show==="video"'>
      </div>
      <iframe frameborder="0"
              height="600px"
              width="100%"
              scrolling="no"
              allowfullscreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              :src="url"
              class="iframe"
              :style="{height: `${height}px`,width: `${width}px`}"
              v-if='show==="iframe"'>
      </iframe>
      </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'modal',
  props: {
  },
  data() {
    return {
      vid: '',
      url: '',
      show: '',
    };
  },
  mounted() {
    if (this.$store.state.modal.mode === 'video') {
      this.vid = this.$store.state.modal.value;
      this.show = 'video';
      this.showVideo(this.vid);
    } else {
      this.url = this.$store.state.modal.value;
      this.showIframe();
    }
  },
  methods: {
    close() {
      this.$store.commit('updateModalStatus', {
        modal: {
          show: false,
          mode: '',
          value: '',
        },
      });
    },
    showIframe() {
      this.show = 'iframe';
    },
    showVideo() {
      /* eslint-disable */
      this.player = polyvPlayer({
          wrap: "#video",
          width: this.width,
          height: this.height,
          vid: this.vid,
          autoplay: false,
          forceH5: true,
          skinLocation: 1,
        });
        let that = this
        this.player.on('s2j_onVideoPlay',function(e) {
        //发送停止事件
             console.log('播放',that.$store.state.videoId)
             that.$store.commit("updateVideoId",{videoId:'modal_video'}) 
        }); 
    },
  },
  computed:{
      ...mapState({
         height:state=>state.pageHeight,
         width:state=>state.pageWidth
      })
  }
};
</script>
<style lang="less" scoped>
.modal-cont{
    //overflow: hidden;
    z-index: 1000;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background:#2c3e508a;
    .modal{
       min-width: 300px;
       min-height:200px;
       &-nav{
           width: 100%;
           height: 38px;
           background-color: white;
           border-top-right-radius:10px ;
           border-top-left-radius:10px ;
           position: relative;
        &-close-btn{
            width: 22px;
            height: 22px;
            background: url("~@/assets/icon/navClose.png");
            top: 9px;
            right: 11px;
            position: absolute;
            color: white;
            line-height: 18px;
            font-size: 10px;
            cursor: pointer;
        }
        
       }
       display:inline-block;
       .iframe{
            width: 1000px;
        }
        
    }
}

</style>
